import { Icon } from "@iconify/react/dist/iconify.js"
import { Link } from "react-router-dom"

const LIMIT_OPTIONS = [10, 20, 50, 100, 200];

export const PaginationLimit = ({ currentPage = 1, totalRecords = 10, limit = 10, handleLimitChange = () => void (0), handlePageChange = () => { }, handlePageNext = () => { } }) => {
    // A limit set elsewhere (a page defaulting to 25, say) stays selectable.
    const limitOptions = LIMIT_OPTIONS.includes(Number(limit))
        ? LIMIT_OPTIONS
        : [...LIMIT_OPTIONS, Number(limit)].sort((a, b) => a - b);

    // "Showing 31 to 40 of 35" was possible on the last page.
    const firstRecord = totalRecords === 0 ? 0 : (currentPage - 1) * limit + 1;
    const lastRecord = Math.min(currentPage * limit, totalRecords);

    return (
        <div className=" mt-24 d-flex md:flex-wrap flex-wrap align-items-center  justify-content-between gap-3">
            <div className="d-flex gap-2 align-items-center">

                <span>Select Limit</span>

                {/* Fixed choices. These were derived from the record count and the
                    current page, so a short list only ever offered 10 and 20 and the
                    options changed as you paged. `value` + onChange (not defaultValue
                    with `selected` options) keeps the box showing the live limit. */}
                <select
                    className="form-select form-select-sm w-auto"
                    value={limit}
                    onChange={handleLimitChange}
                >
                    {limitOptions.map((option) => (
                        <option key={option} value={option}>{option}</option>
                    ))}
                </select>
            </div>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2  ">
                <span>Showing {firstRecord} to {lastRecord} of {totalRecords} records</span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                    <li className="page-item">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a href="#" className={` ${currentPage !== 1 ? '' : ' tw-pointer-events-none text-muted tw-opacity-[0.5]'} page-link bg-neutral-200 text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px  me-8 w-32-px`}
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            <Icon icon="ep:d-arrow-left" className="text-xl" />
                        </a>
                    </li>
                    {(Math.ceil(totalRecords / limit) - currentPage) === 0 ?
                        ''
                        : Array.from({ length: (Math.ceil(totalRecords / limit) - currentPage) }, (_, index) => {
                            return (index > 2 ? '' : <Link
                                className="page-link bg-primary-50 text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px  me-8 w-32-px"
                                onClick={() => handlePageChange(index + currentPage + 1)}
                            >
                                {index + currentPage + 1}
                            </Link>)

                        })}


                    {<li className="page-item">
                        <Link
                            className={` ${(Math.ceil(totalRecords / limit) - currentPage) <= 0 ? ' tw-pointer-events-none text-muted tw-opacity-[0.5]' : ''} page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-neutral-200`}
                            onClick={() => handlePageChange(currentPage + 1)}

                        >
                            {" "}
                            <Icon icon="ep:d-arrow-right" className="text-xl" />{" "}
                        </Link>
                    </li>}
                </ul>
            </div>
        </div>
    )
}